module.exports = __webpack_public_path__ + "static/img/0003.7c14309.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0003.jpg
// module id = jT+r
// module chunks = 0